module.exports = __webpack_public_path__ + "static/media/obol.75c0aabd.svg";